

export const cp9 = {
  name: 'Deciding and Initiating Action',
  description: 'Taking control and exercises leadership. Initiates action, gives direction and takes responsibility',
  levels:[
    { name: 'Formulates clear decision criteria',
    indicators: [
      { score: '1', text: 'Recognizes issues, problems, and opportunities and determine whether action is needed'},
      { score: '2', text: 'Considers trends and patterns as part of the decision criteria' },
      { score: '3',text: 'Considers trends, patterns, and impact in the decision criteria' }
    ]
  },
{ name: 'Generates alternatives',
    indicators: [
      { score: '1', text: 'Identifies possible options from the available information'},
      { score: '2', text: 'Creates relevant options for addressing problems/opportunities and achieving desired outcomes.' },
      { score: '3',text: 'Evaluates options by considering implications and consequences; chooses an effective option.' }
    ]
  },
{ name: 'Takes the initiative to make prompt and clear decisions which may involve tough choices or considered risks',
    indicators: [
      { score: '1', text: 'Responds quickly, takes immediate action when confronted with a problem or when made aware of a situation. '},
      { score: '2', text: 'Takes independent action, implements ideas or potential solutions without prompting, and doesn’t wait for others to request for action. ' },
      { score: '3',text: 'Takes action that goes beyond job requirements in order to achieve objectives. ' }
    ]
  },
{ name: 'Takes responsibility for actions, projects, and people',
    indicators: [
      { score: '1', text: 'Provides encouragement and support to others in accepting responsibility; does not accept others’ denial of responsibility without questioning.'},
      { score: '2', text: 'Accepts responsibility for outcomes (positive or negative) of one’s work; admits mistakes and refocuses efforts when appropriate.' },
      { score: '3',text: 'Creates climate of responsibility and holds individuals directly accountable' }
    ]
  },
{ name: 'Involves others',
    indicators: [
      { score: '1', text: 'Encourages involvement from others '},
      { score: '2', text: 'Listens to and fully involves others in team decisions and actions; values individual differences and talents' },
      { score: '3',text: 'Includes others in the decision-making process as warranted to obtain good information, make the most appropriate decisions, and ensure buy-in and understanding of the resulting decisions.' }
    ]
  }

  ]
}


export const cp8 = {
  name: 'Delivering results and meeting customer expectation',
  description: 'Focuses on customer satisfaction and delivers a quality service or product to the agreed standards.',
  levels:[
    { name: 'Focuses on customer needs and satisfaction',
    indicators: [
      { score: '1', text: 'Actively seeks information to understand customers’ circumstances, problems, expectations, and needs; Acts as a trusted adviser to the customer'},
      { score: '2', text: 'Implements effective ways to monitor and evaluate customer concerns, issues, and satisfaction.' },
      { score: '3',text: 'Identifies and anticipates customer requirements, expectations, and needs' }
    ]
  },
{ name: 'Sets high standard for quality and quanitity',
    indicators: [
      { score: '1', text: 'Demonstrates drive to achieve meaningful results'},
      { score: '2', text: 'Sets high standards and accountability for customer satisfaction' },
      { score: '3',text: 'Displays personal conviction to achieve high standards of quality service and results' }
    ]
  },
{ name: 'Monitors and maintain quality and productivity',
    indicators: [
      { score: '1', text: 'Establishes clear baseline measures against which improvement is measured'},
      { score: '2', text: 'Reviews and reestablishes growth targets to ensure they are SMART and challenging; Seeks to overcome barriers to better results' },
      { score: '3',text: 'Thinks throught the potential return on investment for the business as a means of choosing priorities and setting goals for the business.' }
    ]
  },
{ name: 'Works in a systematic, methodical and orderly way',
    indicators: [
      { score: '1', text: 'Identifies and implements general work structures and processes to accomplish goals'},
      { score: '2', text: 'Identifies and implements appropriate work structures and processes to accomplish goals' },
      { score: '3',text: 'Identifies and implements optimal and reliable work structures and processes to accomplish goals' }
    ]
  },
{ name: 'Consistently achieves project goals',
    indicators: [
      { score: '1', text: 'Identifies and plans the main action steps and resources required to accomplish project goals or objectives'},
      { score: '2', text: 'Identifies a clear, effective, and well sequenced set of actions and resources required to accomplish project goals and objectives, taking into account contigencies, constraints, and thorough process knowledge' },
      { score: '3',text: 'Creates objectives and action plans to carry out strategies for the achievement of the project goals and objectives and creating key linkages back to the strategy' }
    ]
  }

  ]
}


export const cp7 = {
  name: 'Adapting and responding to change',
  description: 'Adapts and responds well to change. Manages pressure effectively and copes well with setbacks',
  levels:[
    { name: 'Accepts new ideas and change initiatives',
    indicators: [
      { score: '1', text: 'Tries to understand changes in work tasks, situations, and environment as well as the logic or basis for change; actively seeks information about new work situations.'},
      { score: '2', text: 'Advocates the value of the change initiative to help others understand the need for the change; constructively manages resistance to change' },
      { score: '3',text: 'Challenges basic assumptions,norms, and traditions in the face of new information in order to meet broader objectives' }
    ]
  },
{ name: 'Adapts interpersonal style to suit different people or situations',
    indicators: [
      { score: '1', text: 'Understands the requirements of different situations and effectively adapts his/her behavior'},
      { score: '2', text: 'Recognizes when changing customer or organizational expectations require new approaches and takes the necessary steps to meet new standards' },
      { score: '3',text: ' Anticipates changes in the internal and external environment (e.g., organizational, market, products, and systems) and adapts accordingly.' }
    ]
  },
{ name: 'Deals with ambiguity, making positive use of the opportunities it presents. ',
    indicators: [
      { score: '1', text: 'Treats change and new situations as opportunities for learning or growth; focuses on the beneficial aspects of change; speaks positively about the change to others.'},
      { score: '2', text: 'Handles ambiguity and uncertainty calmly and continuing to move forward' },
      { score: '3',text: 'Prioritizes, considers alternatives, and responds quickly and effectively to unexpected and rapidly changing conditions' }
    ]
  },
{ name: 'Demonstrates resilience in the face of rejection, setbacks, and resistance',
    indicators: [
      { score: '1', text: 'Accepts criticism openly and non defensively; accepts responsibility for own mistakes and adapts performance based on experience and feedback.'},
      { score: '2', text: 'Shows resilience in response to rejection, setbacls, criticisms, or resistance' },
      { score: '3',text: 'Recovers quickly and demonstrates strong resilience to different conflicting situations' }
    ]
  },
{ name: 'Pursues ways to develop and apply new capabilities',
    indicators: [
      { score: '1', text: 'Shows interest in developing and applying new skills'},
      { score: '2', text: 'Proactively pursues a wide range of development options and applies new skills on the job' },
      { score: '3',text: 'Regularly evaluates one\'s own capabilities to identify development priorities and target growth opportunities' }
    ]
  }

  ]
}

export const cp6 = {
  name: 'Persuading and influencing',
  description: 'communicates and networks effectively. Successfully persuades and influences others. Relates to others in a confident and relaxed manner',
  levels:[
    { name: 'Makes strong personal impression on others',
    indicators: [
      { score: '1', text: 'Shows consistency in words and action'},
      { score: '2', text: 'Provides facts and information in an open and straightforward manner and doesn\'t distort information with own biases' },
      { score: '3',text: 'Builds a reputation of credibility by presenting information based on solid evidence and rigorous analysis despite conflict with own interest' }
    ]
  },
{ name: 'Gains clear agreement and commitment from others by persuading, convincing, and negotiating',
    indicators: [
      { score: '1', text: 'Uses facts and logic as the main means of persuasion'},
      { score: '2', text: 'Analyzes and undertands others\' motivations and values and acts to reflect or appeal to them' },
      { score: '3',text: 'Uses appropriate influence strategies (such as demonstrating benefits or giving rewards) to gain genuine agreement; persists by using different approaches as needed to gain commitment.' }
    ]
  },
{ name: 'Encourages the open exchange of information and viewpoints',
    indicators: [
      { score: '1', text: 'Create venues for open dialogue where information and viewpoints are shared '},
      { score: '2', text: 'Encourages others to openly exchange information ' },
      { score: '3',text: 'Actively encourages others to openly and frequently exchange information and viewpoint' }
    ]
  },
{ name: 'Makes effective use of political processes to influence and persuade others',
    indicators: [
      { score: '1', text: 'Establishes good interpersonal relationships by helping people feel valued, appreciated, and included in discussions (enhances self-esteem, empathizes, involves, discloses, supports).'},
      { score: '2', text: 'Actively seeks to maintain good relationships with key stakeholders who have relevant influence' },
      { score: '3',text: 'Builds new alliances and creates coalitions of support to gain backing' }
    ]
  },
{ name: 'Maintains positive relationship even under difficult circumstances',
    indicators: [
      { score: '1', text: 'Relates confidently with people at all levels under different circumstances'},
      { score: '2', text: 'Objectively views the conflict from all sides and stays focused on resolving the conflict and avoid personal issues and attacks.' },
      { score: '3',text: 'Takes positive action to resolve the conflict in a way that addresses the issue, dissipates the conflict, and maintains the relationship.' }
    ]
  }

  ]
}

export const cp5 = {
  name: 'Working with people',
  description: 'Supports others and shows respect and positive regard for them in social situations. Puts people first, working effectively with individuals, teams, clients, and staff',
  levels:[
    { name: 'Demonstrates an interest in and understanding of others',
    indicators: [
      { score: '1', text: 'Seeks to understand and address the interest of others especially for those with opposing view points'},
      { score: '2', text: 'Demonstrates efforts to understand and address the interest of others especially for those with opposing view points' },
      { score: '3',text: 'Shows a strong commitment to understand and openly address the concerns and interests of others' }
    ]
  },
  { name: 'Adapts to the team and builds team spirit',
  indicators: [
    { score: '1', text: 'Adjusts oneself to the dynamics of the team and initiates activities to build team cohesiveness'},
    { score: '2', text: 'Works closely with team to remove barriers to collaboration' },
    { score: '3',text: 'Actively builds bridges by facilitating connections, promoting sharing of resources and practices to remove barriers to cooperation' }
  ]
},
{ name: 'Recognizes and rewards the contribution of others',
  indicators: [
    { score: '1', text: 'Provides timely and appropriate recognition and rewards'},
    { score: '2', text: 'Celebrates and rewards significant contribution of others to encourage better participation ' },
    { score: '3',text: 'Creatively rewards significant contribution of others to increase engagement ' }
  ]
},
{ name: 'Listens, consults others and communicates proactively',
  indicators: [
    { score: '1', text: 'Demonstrates ability to listen, consult others, and communicate effectively'},
    { score: '2', text: 'Identifies other\'s unspoken concerns and appreciates different perspectives of others' },
    { score: '3',text: 'Brings individuals and groups closer together based on common goals and discourages ""we"" vs ""they"" thinking' }
  ]
},
{ name: 'Develops and openly communicates self- insight such as an awareness of own strengths and weaknesses',
  indicators: [
    { score: '1', text: 'Reflects on own skills, behavior, and performance. '},
    { score: '2', text: 'Is open with others about own limitations, knows when to ask for help and when to ask for feedback' },
    { score: '3',text: 'Chooses roles and projects that provide an opportunity to use known strengths' }
  ]
}

  ]
}

export const cp4 = {
  name: 'Leading and supervising',
  description: 'Takes control and exercises leadership. Initiates action, gives direction, and takes responsibility',
levels:[
  { name: 'Sets high standard of performance for himself and for the team',
  indicators: [
    { score: '1', text: 'Uses the performance management system to set clear goals and direction, as well as the appropriate measures of performance'},
    { score: '2', text: 'Sets challenging goals for himself and for the team and ensures its alignment with the company\'s objectives.' },
    { score: '3',text: 'Translates company objectives and strategy into bold and ambituous standard that raise the bar of performance for himself and for the team.' }
  ]
},
{ name: 'Ensures compliance with organizational rules and policies',
  indicators: [
    { score: '1', text: 'Has the ability to communicate and implement properly  (ex: disciplinary rules)'},
    { score: '2', text: 'Supports communication and actions in relation to compliance with organizational rules and policies (ex: disciplinary rules, benefits, etc)' },
    { score: '3',text: 'Consistently advocates for or ensures systems are utilized that require compliance with organizational rules and policy (ex., disciplinary rules, benefits, etc.)' }
  ]
},
{ name: 'Delegates work appropriately and fairly',
  indicators: [
    { score: '1', text: 'Delegates responsibility with clear expectations'},
    { score: '2', text: 'Delegates tasks and associated accountabilities that are within the capabilities and responsibility of the staff' },
    { score: '3',text: 'Delegates significant responsibility and authority allowing others to make substantive contributions and efficiently utilize available resources; conveys specific, observable, and measurable expectations for assignment. ' }
  ]
},
{ name: 'Motivates and empowers others',
  indicators: [
    { score: '1', text: 'Conveys confidence in other\'s ability to do their best'},
    { score: '2', text: 'Keeps others motivated by explaining how their work impacts or supports the success of the team' },
    { score: '3',text: 'Energizes others by clarifying the broader purpose and mission of their work' }
  ]
},
{ name: 'Provides staff with development opportunities and coaching',
  indicators: [
    { score: '1', text: 'Provides appropriate and timely intervention to enhance strengths while addressing challenge areas'},
    { score: '2', text: 'Ensures the implementation of appropriate intervention' },
    { score: '3',text: 'Provides opportunities where improved capabilities can be applied' }
  ]
}

]


}

export const cp3 = { name: 'Analyzing',
  description: 'Shows evidence of clear analytical thinking. Gets to the heart of complex problems and issues.',
  levels: [{ 
      name: 'Breaks information into component parts, patterns and relationships',
      indicators: [
        { score: '1', text: 'Breaks down day-to-day problems and issues into managable components'},
        { score: '2', text: 'Breaks down complex problems and issues into manageable components and identifies the root cause.' },
        { score: '3',text: 'Breaks down more complex problems into actionable components to make progress on issues and concerns' }
      ]
    },
    { 
      name: 'Probes for further information or greater understanding of a problem',
      indicators: [
        { score: '1', text: 'Collects sufficient information to understand problems and issues'},
        { score: '2', text: 'Considers precedents and symptoms, to obtain deeper understanding of a problem' },
        { score: '3',text: 'Probes sufficiently into issues and problems to understand the underlying causes and identifies specific information needed to ensure full understanding' }
      ]
    },
    { 
      name: 'Makes rational judgements from the available information and analysis',
      indicators: [
        { score: '1', text: 'Applies existing rules and procedures to make judgement'},
        { score: '2', text: 'Uses common sense and appropriate logic in making decisions' },
        { score: '3',text: 'Balances common sense, logic, and values in making decisions' }
      ]
    },
    { 
      name: 'Detects inaccuracies or flaws in reasoning',
      indicators: [
        { score: '1', text: 'Recognizes symptoms that indicate inaccuracies or flaws in reasoning'},
        { score: '2', text: 'Detects flaws in reasoning' },
        { score: '3',text: 'Accurately detects flaws in reasoning' }
      ]
    },
    { 
      name: 'Focuses on important information without getting bogged down in unnecessary detail',
      indicators: [
        { score: '1', text: 'Recognizes value adding information and doesn\'t get distracted by petty details'},
        { score: '2', text: 'Focuses problem solving on important information' },
        { score: '3',text: 'Clearly focuses on the most relevant information needed to understand the problem or issue and doesn’t waste time on details that will not add significantly to resolution of the issue' }
      ]
    }
  ]
}

export const cp2 = { name: 'Entrepreneurial and commercial thinking', 
                        description: 'Demonstrates understanding of business, commerce, and finance, paying particular attention to cost, expenses, and revenues',
                        levels: [{ 
                          name: 'Accurately forecasts cost and expenditures',
                          indicators: [
                            { text: 'Tracks and reports expenses and ensures alignment with the budget',
                              score: '1'},
                            { text: 'Identifies and estimates contributor to cost',
                              score: '2'},
                              { text: 'Forecasts the cost and revenue potential on business opportunities',
                              score: '3'}
                          ]
                        },
                        { 
                            name: 'Draws appropriate conclusions from financial data to support prudent decisions and actions',
                            indicators: [
                                { text: 'Collects and understands data used for financial metrics to optimize operational cost',
                                score: '1'},
                                { text: 'Draws accurate conclusions from financial and quantitative information to identify cost saving measures/ programs',
                                score: '2'},
                                { text: 'Makes generally sound decisions regarding expenditures taking into consideration relevant factors impacting the business',
                                score: '3'}
                            ]
                          },
                          { 
                            name: 'Delivers appropriate messages about past financial performance and future expectations based on an accurate interpretation, relevant, patterns, trends, and deviations ',
                            indicators: [
                              { text: 'Provides interpretations about past financial performance based on performance, patterns, trends, and deviations',
                                score: '1'},
                              { text: 'Delivers general messages about the financial performance to top management that are based on patterns, trends and deviation.',
                                score: '2'},
                                { text: 'Delivers accurate and realistic messages about the financial performance to top management that are based on detailed interpretation of relevant patterns, trends, and deviation.',
                                score: '3'}
                            ]
                          },
                          { 
                            name: 'Keeps up to date with competitor information and market trends',
                            indicators: [
                              { text: 'Exhibits interest on competitor activities and implements approved programs based on market best practices',
                                score: '1'},
                              { text: 'Monitors competitor activities and recommends programs based on market best practices',
                                score: '2'},
                                { text: 'Uses competitor and external information to develop programs  that will enable the business to be ahead of the competition',
                                score: '3'}
                            ]
                          },
                          { 
                            name: 'Capitalizes on the business strengths to generate opportunities while managing potential risks/ threats',
                            indicators: [
                              { text: 'Exhibits general awareness of business strengths and weaknesses',
                                score: '1'},
                              { text: 'Uses one\'s in depth understanding of business strengths and weaknesses to come up with initiatives that will create business opportunities while identifying potential risks/ threats.',
                                score: '2'},
                                { text: 'Challenges business assumptions and generates options based on the company\'s strength, weakness, and risks to help the business become more competitive',
                                score: '3'}
                            ]
                          }
                        ]
                }

export const cp1 = { name: 'Formulating strategies and concepts', 
                description: 'Thinks broadly and strategically. Supports and drives organizational change.',
                levels: [{ 
                  name: 'Shows awareness to internal and external trends that may affect the team/ organization.',
                  indicators: [
                    { text: 'Displays sufficient understanding of how own and team\'s tasks relate to the bigger picture',
                      score: '1'},
                    { text: 'Demonstrates in depth understanding of organization\'s mission, vision, and strategies',
                      score: '2'},
                      { text: 'Demonstrates understanding of the key industry trends and conditions with consideration on the effect with other areas',
                      score: '3'}
                  ]
                },
                { 
                    name: 'Communicates GCI’s strategic priorities in a compelling and convincing manner, encouraging buy-in',
                    indicators: [
                        { text: 'Works to clarify and understand the broader purpose and mission of own work.',
                        score: '1'},
                        { text: 'Motivates others who are unclear or not aligned with the corporate strategy by explaining the rationale and big picture',
                        score: '2'},
                        { text: 'Champions the business strategy and ensures alignment',
                        score: '3'}
                    ]
                  },
                  { 
                    name: 'Sets clear objectives, action plans, and manages team resources',
                    indicators: [
                      { text: 'Clearly defines their objectives and develops a strategic action plan with each objective broken down into tasks and each task having a list of needed resources and a specific timeline.',
                        score: '1'},
                      { text: 'Aligns all activities with the work group\'s goals and strategies',
                        score: '2'},
                        { text: 'Makes decision and pursues initiatives that are generally consistent with the organization\'s broader strategies and directions',
                        score: '3'}
                    ]
                  },
                  { 
                    name: 'Adopts a systems perspective-- understands the implications of daily actions to the business',
                    indicators:   [        {id: "oJVCMSG0V9VQeHO5pvJO", score: "1", text: "Recognizes internal factors that may affect the direction of the team and uses this awareness to come up with solutions to key business problems."},
                    {id: "z07JXtM8vUzsxppit5Np", score: "2", text: "Integrates and balances big picture concern with the day to day activities"},        
                    {id: "YXJVBVlFMrJ6DJvP2WUq", score: "3", text: "Strikes a general balance between addressing long term issues and day to day activities"}]
                  
                  },
                  { 
                    name: 'Ensures that initiatives and priorities of own area are integrated appropriately with each other',
                    indicators: [
                      { text: 'Prioritizes works and activities based on impact to the work group goals',
                        score: '1'},
                      { text: 'Prioritizes works and activities based on impact to departmental goals',
                        score: '2'},
                        { text: 'Pursues initiatives and priorities without competing or detracting from the success of one another',
                        score: '3'}
                    ]
                  }
                ]
        }


// WEBPACK FOOTER //
// ./src/admin/containers/cps-gci.js